import { match, P } from "ts-pattern";
import { BreakdownProtected } from "../../apr-display-v2/breakdown/breakdown-protected";
import { KeyValueList } from "../../key-value-list";
import { TotalApr } from "./total-apr";
import { DepositProjectedAprDescription } from "../descriptions";
import { Percent } from "@silo/types";
import { ProtectedAprMetrics } from "@silo/utils";

interface ProjectedAprProps {
  newMetrics: ProtectedAprMetrics | null;
  newRevenueApr: Percent;
}

export function ProjectedApr({
  newMetrics,
  newRevenueApr,
}: ProjectedAprProps): JSX.Element {
  return (
    <KeyValueList.Pair
      description={<DepositProjectedAprDescription />}
      trailingContent={
        newMetrics ? (
          <TrailingContent
            newMetrics={newMetrics}
            newRevenueApr={newRevenueApr}
          />
        ) : undefined
      }
      trailingContentContainerClassName="gap-0"
    >
      <KeyValueList.Key>Projected APR</KeyValueList.Key>

      <KeyValueList.Value>
        {match(newMetrics)
          .with(
            P.nonNullable,
            ({ hasProtectedIncentives, totalProtectedApr }) => (
              <TotalApr
                hasProtectedIncentives={hasProtectedIncentives}
                totalProtectedApr={totalProtectedApr}
              />
            )
          )
          .otherwise(() => "--")}
      </KeyValueList.Value>
    </KeyValueList.Pair>
  );
}

interface TrailingContentProps {
  newMetrics: ProtectedAprMetrics;
  newRevenueApr: Percent;
}

function TrailingContent({
  newMetrics,
  newRevenueApr,
}: TrailingContentProps): JSX.Element | null {
  const { hasProtectedIncentives, protectedRewards } = newMetrics;

  if (!hasProtectedIncentives) return null;

  return (
    <BreakdownProtected
      className="gap-0 text-sm"
      protectedRewards={protectedRewards}
      align="right"
      revenueApr={newRevenueApr}
    />
  );
}
